import * as React from 'react';
import ContentLoader, {IContentLoaderProps} from 'react-content-loader';
import {useTheme} from 'styled-components';

export interface LoaderContainerProps extends IContentLoaderProps {
  children: React.ReactNode | React.ReactNodeArray;
};

/**
 * This containers wraps the loader and adds a color scheme to it.
 * @param {LoaderContainerProps} props
 * @constructor
 */
export default function LoaderContainer(
    props: LoaderContainerProps,
): React.ReactElement<LoaderContainerProps> {
  const theme = useTheme();
  return (
    <ContentLoader
      speed={2}
      backgroundColor={theme.variables.backgroundColor}
      foregroundColor={theme.variables.accentBackgroundColor}
      {...props}
    />
  );
}
